import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

import {PartnerStat} from '../../../../../models/statistic/partner-stat';
import {MoneyPipe} from '../../../../../pipes/money/money.pipe';
import {Partner} from '../../../../../models/partner/partner';
import {last} from 'rxjs';

@Component({
  selector: 'app-annual-performance',
  imports: [
    MoneyPipe
],
  templateUrl: './annual-performance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './annual-performance.component.scss'
})
export class AnnualPerformanceComponent {

  @Input() partner: Partner | null = null;
  @Input() partnerStat: PartnerStat = new PartnerStat();
  @Input() loaded: boolean = false;

  get currentYear(): number {
    return new Date().getFullYear();
  }

  get lastYear(): number {
    return new Date().getFullYear() - 1;
  }

  getRevenue(): number[] {
    return [
      this.partnerStat.currentYearToDate.revenue,
      this.partnerStat.lastYearToDate.revenue
    ];
  }

  getCost(): number[] {
    return [
      this.partnerStat.currentYearToDate.cost,
      this.partnerStat.lastYearToDate.cost
    ];
  }

  getMargin(): number[] {
    return [
      this.partnerStat.currentYearToDate.revenue - this.partnerStat.currentYearToDate.cost,
      this.partnerStat.lastYearToDate.revenue - this.partnerStat.lastYearToDate.cost
    ];
  }

  hasIncreased(values: number[]): boolean {
    return values[0] > values[1];
  }

  isInfinite(values: number[]): boolean {
    return values[1] === 0;
  }

  getChange(values: number[]): unknown {
    const result: number = Math.abs(values[0] - values[1]) / Math.abs(values[1]);

    return Intl.NumberFormat('fr-FR', {style: 'percent', maximumFractionDigits: 0}).format(result);
  }

  protected readonly last = last;
}
